// src/Components/Cart/CartItem.js

import React from 'react';
import { PlusIcon, MinusIcon, TrashIcon } from '../Common/Icons';

const CartItem = ({ item, onUpdateQuantity, onRemoveItem }) => (
  <div className="cart-item">
    <img 
      src={item.imageUrl} 
      alt={item.name} 
      className="cart-item-image" 
    />
    <div className="cart-item-details">
      <h4 className="cart-item-name">{item.name}</h4>

      {item.selectedOptions && Object.keys(item.selectedOptions).length > 0 && (
        <div className="cart-item-options">
          {Object.entries(item.selectedOptions).map(([key, value]) => (
            <span key={key}>{key}: {value}</span>
          )).reduce((prev, curr) => [prev, ', ', curr])}
        </div>
      )}

      <p className="cart-item-price">${item.price.toFixed(2)}</p>
      <div className="cart-item-quantity">
        <button 
          onClick={() => onUpdateQuantity(item.cartItemId, -1)} 
          className="quantity-button" 
          aria-label={`Decrease quantity of ${item.name}`}
        >
          <MinusIcon className="vintage-icon" />
        </button>
        <span className="quantity-display">{item.quantity}</span>
        <button 
          onClick={() => onUpdateQuantity(item.cartItemId, 1)} 
          className="quantity-button" 
          aria-label={`Increase quantity of ${item.name}`}
        >
          <PlusIcon className="vintage-icon" />
        </button>
      </div>
    </div>
    <button 
      onClick={() => onRemoveItem(item.cartItemId)} 
      className="remove-item-button"
      aria-label={`Remove ${item.name} from cart`}
    >
      <TrashIcon className="vintage-icon" />
    </button>
  </div>
);

export default CartItem;